import { Separator } from "@nju/ui";
import { Faq } from "../Faq";
import { InfoChat } from "./InfoChat";

export function DashboardFaqPage() {
  return (
    <>
      <Faq />
      <Separator size="m" tone="invisible" />
      <InfoChat />
    </>
  );
}
